import { useEffect, useState } from "react";
import { useOutletContext, Link } from "react-router-dom";
import { TabNames } from "../Assets/variables";
import Images from "../Assets/Images/images";
import APIOverviewExample from "./APIOverviewExample";
import { separateWords, capitalizeWord, acronymTransformer, replaceUnderscore } from "../Utils/contentTransformers";

function formatFieldName(fieldName) {
    let fieldNameWordsArray = separateWords(fieldName);
    fieldNameWordsArray = fieldNameWordsArray.map(fieldNameWord => capitalizeWord(fieldNameWord));
    fieldNameWordsArray = fieldNameWordsArray.map(fieldNameWord => acronymTransformer(fieldNameWord));
    fieldNameWordsArray = fieldNameWordsArray.join(" ");
    return fieldNameWordsArray;
}

function formatListTitle(fieldName) {
    let fieldNameWordsArray = separateWords(fieldName);
    fieldNameWordsArray = fieldNameWordsArray.map(fieldNameWord => fieldNameWord.toUpperCase());
    fieldNameWordsArray = fieldNameWordsArray.join(" ");
    return fieldNameWordsArray;
}

function getBusinessName(overviewList, index) {
    let baseType = Object.keys(overviewList[index].referenceData);

    switch(baseType[0]) {
        case "instrumentMarkets":
            return overviewList[index].lookup.instrumentShortName;
    }
}

function getBusinessType(overviewList, index) {
    let baseType = Object.keys(overviewList[index].referenceData);

    switch(baseType[0]) {
        case "instrumentMarkets":
            return overviewList[index].lookup.instrumentType;
    }
}

function getBusinessField(overviewList, index) {
    let baseType = Object.keys(overviewList[index].referenceData);

    switch(baseType[0]) {
        case "instrumentMarkets":
            return overviewList[index].referenceData.instrumentMarkets;
    }
}

const MainList = (props) => {
    let innerLists;
    let overviewList = getBusinessField(props.overviewList, props.activeFieldSet);
    console.log(overviewList)

    innerLists = Object.keys(overviewList).map(key => {
        if (typeof overviewList[key] === 'object') {
            let innerList;

            innerList = Object.keys(overviewList[key]).map(innerKey => {
                return (
                    <div className="overview-list-item">
                        <p className="field-name">{formatFieldName(innerKey)}</p>
                        { (typeof overviewList[key][innerKey] == "object") &&
                            <ul>
                                {
                                    overviewList[key][innerKey].map(value => {
                                        return (
                                            <li className="field-value">{value}</li>
                                        )}
                                    )
                                }
                            </ul>
                        }
                        { (typeof overviewList[key][innerKey] == "string" || typeof overviewList[key][innerKey] == "number") &&
                            <p className="field-value">{overviewList[key][innerKey]}</p>
                        }
                    </div>
                )
            })

            return (
                <div className="inner-overview-list">
                    <h5 className="list-title">{formatListTitle(key)}</h5>
                    {innerList}
                </div>
            );
        }
    });

    return (
        <div className="main-overview-lists">
            {innerLists}
        </div>
    );
}

const InnerList = (props) => {
    let innerLists;
    let overviewList = getBusinessField(props.overviewList, props.activeFieldSet);

    innerLists = Object.keys(overviewList).map(key => {
        if (typeof overviewList[key] === 'object') {
            let innerList;

            innerList = Object.keys(overviewList[key]).map(innerKey => {
                return (
                    <div className="overview-list-item">
                        <p className="field-name">{formatFieldName(innerKey)}</p>
                        { (typeof overviewList[key][innerKey] == "object") &&
                            <ul>
                                {
                                    overviewList[key][innerKey].map(value => {
                                        return (
                                            <li className="field-value">{value}</li>
                                        )}
                                    )
                                }
                            </ul>
                        }
                        { (typeof overviewList[key][innerKey] == "string" || typeof overviewList[key][innerKey] == "number") &&
                            <p className="field-value">{overviewList[key][innerKey]}</p>
                        }
                    </div>
                )
            })

            return (
                <div className="inner-overview-list">
                    <h5 className="list-title">{formatListTitle(key)}</h5>
                    {innerList}
                </div>
            );
        }
    });

    return (
        <div className="inner-overview-lists">
            {innerLists}
        </div>
    );
}

const APIOverviewExampleInstrumentMarkets = () => {
    const {setActiveTabItem, apiInfo} = useOutletContext();
    let overviewList = apiInfo.example;
    let [activeFieldSet, setActiveFieldSet] = useState(0);

    useEffect(() => {
        setActiveTabItem(TabNames.Overview);
    }, []);
    
    return (
        <>
            <div id="tab-overview" className="api-panel">
                <div className="tab-overview__content">
                    <div className="left-side">
                        <p id="overview-description" dangerouslySetInnerHTML={{ __html: apiInfo.overviewDescription }}></p>
                        <Link
                            id="six-button-trial"
                            className="six-button six-button--action"
                            to={'https://www.six-group.com/en/products-services/financial-information/display-and-delivery-capabilities/six-api/demo.html'}
                            target="_blank">
                            Request a trial
                        </Link>
                    </div>
                    {apiInfo.hasImage &&
                        <div className="right-side">
                            {apiInfo.hasUniquesImage
                                ? <img id="tab-overview__image" src={Images[apiInfo.apiName]} alt={`${apiInfo.apiTitle} overview`} />
                                : <img id="tab-overview__image" src={Images.DefaultAPIImage} alt={`${apiInfo.apiTitle} overview`} />
                            }
                        </div>
                    }
                </div>
                {apiInfo.example &&
                    <>
                        <h4 id="example-title">Example</h4>
                        <div id="tab-overview-example-data" className="instrument-markets-example">
                            <div className="example-buttons">
                                {
                                    overviewList.map((business, index) => {
                                        return (
                                            <button
                                                className={"example-button " + (index === activeFieldSet ? "example-button--active" : "")}
                                                onClick={() => {
                                                    setActiveFieldSet(index);
                                                }}>
                                                <p className="name">{getBusinessName(overviewList, index)}</p>
                                            </button>
                                        )}
                                    )
                                }
                                </div>
                                <div className="example-content">
                                    <div className="instrument-name">
                                        <h2 className="overview-example-name">{getBusinessName(overviewList, activeFieldSet)}</h2>
                                        <h3 className="overview-example-type">{replaceUnderscore(getBusinessType(overviewList, activeFieldSet))}</h3>
                                    </div>
                                    <div className="overview-lists">
                                        <MainList activeFieldSet={activeFieldSet} overviewList={overviewList} />
                                        <InnerList activeFieldSet={activeFieldSet} overviewList={overviewList} />
                                    </div>
                                </div>
                        </div>
                    </>
                }
            </div>
        </>
    );
};

export default APIOverviewExampleInstrumentMarkets;